/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Whyh_SubInputs */

const en_wc_whyh_sub = /** @type {(inputs: Wc_Whyh_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know the editor before you choose it. These features are a starting point; our tutorials and Microsoft Word comparison explain how they fit everyday writing tasks.`)
};

/**
* | output |
* | --- |
* | "Get to know the editor before you choose it. These features are a starting point; our tutorials and Microsoft Word comparison explain how they fit everyday w..." |
*
* @param {Wc_Whyh_SubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_whyh_sub = /** @type {((inputs?: Wc_Whyh_SubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Whyh_SubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_whyh_sub(inputs)
});
export { wc_whyh_sub as "wc.whyh.sub" }